/**
 * Display helpers for vintage values that account for Non-Vintage (NV) wines.
 */

export interface VintageHolder {
  vintage?: number | null;
  isNV?: boolean;
}

/** Renders a vintage for display: "NV" for non-vintage wines, otherwise the year string (or empty). */
export function displayVintage(w: VintageHolder | null | undefined): string {
  if (!w) return '';
  if (w.isNV) return 'NV';
  if (w.vintage == null || Number(w.vintage) === 0) return '';
  return String(w.vintage);
}
